import { combineReducers } from 'redux';
import { reducer as timelineData } from './data';
import { reducer as timelineConfig } from './config';
import { reducer as uiReducer } from './ui';
import { reducer as sharingReducer } from './sharing';
import { reducer as requestReducer } from './request';
import { reducer as tempDashboard } from './tempDashboard';
import { reducer as dashboard } from './dashboard';

export default combineReducers({
  timelineData,
  ui: uiReducer,
  timelineConfig,
  sharing: sharingReducer,
  request: requestReducer,
  tempDashboard,
  dashboard,
});
